/** Input types that take a click or a pick rather than typed text. */
const NON_TEXT_INPUT_TYPES = new Set([
  "button",
  "checkbox",
  "color",
  "file",
  "hidden",
  "image",
  "radio",
  "range",
  "reset",
  "submit",
]);

/**
 * Whether the user is typing in a field outside `scope`, so a canvas card
 * arriving now must leave focus where it is.
 *
 * The agent can put a card on the canvas by itself, at the end of a run, while
 * the user is mid-sentence in the composer. Moving focus into that card cut the
 * sentence off (BIG-9498). A card the user opened themselves is unaffected: the
 * click that opened it already took focus off the field.
 */
export function isTypingOutside(scope: Element): boolean {
  const active = document.activeElement;
  if (!(active instanceof HTMLElement) || scope.contains(active)) return false;
  if (active.isContentEditable || active instanceof HTMLTextAreaElement) return true;
  return active instanceof HTMLInputElement && !NON_TEXT_INPUT_TYPES.has(active.type);
}
